export default "__VITE_ASSET__DGipQlEs__"